import { GIFT_CATALOGUE as GCCAT_DATALAYER } from '../../datalayer/data/gift_catalogue.js';

// Product is an object that contains only the following attributes:
// * id
// * title
// * price
// * img_url
export function update_card_datalayer(
    product,
    ispromo,
    position,
    list_name,
    collection_title
) {
    // let is_promo = product.metafields['global']['isPromo'];
    // GCCAT_DATALAYER.isPromo = ispromo;
    // GCCAT_DATALAYER.pageType = 'product list';
    GCCAT_DATALAYER.id.push(product.id);
    GCCAT_DATALAYER.name.push(product.title);
    GCCAT_DATALAYER.category.push(collection_title);
    GCCAT_DATALAYER.variant.push('');

    // These are not assigned to utag_data, should it?
    // GCCAT_DATALAYER.price.push(product.price);
    // GCCAT_DATALAYER.list_name.push(list_name);
    // GCCAT_DATALAYER.list_position.push(position);

    if (ispromo === 'true') {
        GCCAT_DATALAYER.promo_id.push(product.id);
        GCCAT_DATALAYER.promo_name.push(product.title);
        GCCAT_DATALAYER.promo_reative.push(product.img_url);
        GCCAT_DATALAYER.promo_position.push(position);
    } else {
        GCCAT_DATALAYER.promo_id.push('');
        GCCAT_DATALAYER.promo_name.push('');
        GCCAT_DATALAYER.promo_creative.push('');
        GCCAT_DATALAYER.promo_position.push('');
    }
}
